import { render, staticRenderFns } from "./MRC_ESS_Form_ApprovalTriger.vue?vue&type=template&id=7d9e7f0c&"
import script from "./MRC_ESS_Form_ApprovalTriger.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_Form_ApprovalTriger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VBtn,VChip,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d9e7f0c')) {
      api.createRecord('7d9e7f0c', component.options)
    } else {
      api.reload('7d9e7f0c', component.options)
    }
    module.hot.accept("./MRC_ESS_Form_ApprovalTriger.vue?vue&type=template&id=7d9e7f0c&", function () {
      api.rerender('7d9e7f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_Form_ApprovalTriger.vue"
export default component.exports